import * as Yup from 'yup'

export const depositSchema = () =>
  Yup.object().shape({
    bonusTimes : Yup.number()
      .typeError('Only numbers are allowed')
      .min(0, 'Bonus Variant should be greater than 0')
      .required('Bonus Variant Required')
  })
